module.exports = __webpack_public_path__ + "img/site-mismatch.022e167a.svg";